var map = {
	"./leaves.jpg": 40,
	"./me-dark-paper.jpg": 26,
	"./me-transparent.png": 41,
	"./me-white.jpg": 42,
	"./me.jpg": 43,
	"./pageup-big.png": 44,
	"./pageup.png": 45,
	"./paper-inverse.jpg": 25,
	"./paper-light.jpg": 46,
	"./paper.jpg": 24,
	"./serverless_logo_fire.gif": 47
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;



//////////////////
// WEBPACK FOOTER
// ./src/images \.(png|jpg|gif)$
// module id = 39
// module chunks = 0